export default "__VITE_ASSET__BHpmDjfR__"